import {axios} from '@/_metronic/helpers/network/Axios'
import {AxiosResponse} from 'axios'
import {
  FilterReportTrendAnalysis,
  ReportTrendAnalysisQueryResponse,
  Top5Product,
  TopFiveTherapist,
  TrendCategory,
  TrendGender,
  TrendTreatment,
} from './_models'
import {BaseResponse} from '@/_metronic/helpers/crud-helper/base-list-response'

const REPORT_API_URL = '/report-services'
const GET_REPORT_TREND_ANALYSIS_LIST = '/dashboard/trend-analysis'

const getReportTrendAnalysis = (
  body: FilterReportTrendAnalysis
): Promise<ReportTrendAnalysisQueryResponse> => {
  return axios
    .post(`${REPORT_API_URL}${GET_REPORT_TREND_ANALYSIS_LIST}`, body)
    .then((d: AxiosResponse<ReportTrendAnalysisQueryResponse>) => d.data)
}

const getTop5Products = (body: FilterReportTrendAnalysis) =>
  axios
    .post(`${REPORT_API_URL}${GET_REPORT_TREND_ANALYSIS_LIST}/top-5-product`, body)
    .then((d: AxiosResponse<BaseResponse<Top5Product[]>>) => d.data)

const getTop5Therapist = (body: FilterReportTrendAnalysis) =>
  axios
    .post(`${REPORT_API_URL}${GET_REPORT_TREND_ANALYSIS_LIST}/top-5-therapist`, body)
    .then((d: AxiosResponse<BaseResponse<TopFiveTherapist[]>>) => d.data)

const getTrendCategory = (body: FilterReportTrendAnalysis) =>
  axios
    .post(`${REPORT_API_URL}${GET_REPORT_TREND_ANALYSIS_LIST}/category`, body)
    .then((d: AxiosResponse<BaseResponse<TrendCategory[]>>) => d.data)

const getTrendTreatment = (body: FilterReportTrendAnalysis) =>
  axios
    .post(`${REPORT_API_URL}${GET_REPORT_TREND_ANALYSIS_LIST}/treatment`, body)
    .then((d: AxiosResponse<BaseResponse<TrendTreatment[]>>) => d.data)

const getTrendGender = (body: FilterReportTrendAnalysis) =>
  axios
    .post(`${REPORT_API_URL}${GET_REPORT_TREND_ANALYSIS_LIST}/gender`, body)
    .then((d: AxiosResponse<BaseResponse<TrendGender[]>>) => d.data)

export {
  getReportTrendAnalysis,
  getTop5Products,
  getTop5Therapist,
  getTrendCategory,
  getTrendTreatment,
  getTrendGender}
